export enum CustomerOrderTypeEnum {
 Sale,
 Purchase
}
